import { useCallback } from 'react';

import useInquiryForm from './useInquiryForm';
import useInquiryTypes from './useInquiryTypes';

interface Props {
    setInquiryTypeId: ReturnType<typeof useInquiryForm>['setInquiryTypeId'];
    setContent: ReturnType<typeof useInquiryForm>['setContent'];
    inquiryTypes: ReturnType<typeof useInquiryTypes>
}

function useUpdateInquiryType({ setInquiryTypeId, setContent, inquiryTypes }:Props) {
    return useCallback((id: string) => {
        setInquiryTypeId(id);
        const inquiryType = inquiryTypes
            ?.find((type) => type.inquiryTypeId === id);
        setContent(inquiryType?.content || '');
    }, [inquiryTypes]);
}

export default useUpdateInquiryType;
